import { createSlice } from '@reduxjs/toolkit'
import { PatientsListTypes } from 'consts/copilotControlConsts'

const initialState = {
  selectedPatientsListType: PatientsListTypes.NeedsAttention.type,
  selectedNeedsAttentionReasons: []
}

const copilotControlSlice = createSlice({
  name: 'copilotControl',
  initialState,
  reducers: {
    setSelectedPatientsListType: (state, { payload: value }) => {
      state.selectedPatientsListType = value
    },
    setSelectedNeedsAttentionReasons: (state, { payload: value }) => {
      state.selectedNeedsAttentionReasons = value
    }
  }
})

export const { setSelectedPatientsListType, setSelectedNeedsAttentionReasons } = copilotControlSlice.actions

export default copilotControlSlice.reducer
